@if (hasTurn && speedLimit < 130 && speedLimit > 0 && !floatingInfoVisible) {
  <div class="speedlimit-outer">
    <div class="speedlimit">
      <img class="speedlimit-icon" src="assets/icons/light/ui/slider_small_button_battery.svg" alt="speed limit">
      @if (settingsService.getUnit().Speed == 'metric') {
        <div class="speedlimit-value">{{ speedLimit }}</div>
      }
      @if (settingsService.getUnit().Speed == 'imperial') {
        <div class="speedlimit-value">{{ speedLimit * 0.621371192 | valueInteger }}</div>
      }
    </div>
  </div>
}
